// import "./RegistrationGroup.css";

import { Breadcrumb, message, Table, type TableColumnsType, Tag } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import {
  deleteOnboardingStep,
  getOnboardingSteps,
  type OnboardingStepsType,
  useAppSelector,
} from "../../_lib/_store";
import { stripHtml } from "../../_lib/_utils";

export const OnboardingStepsPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, onboardingSteps } = useAppSelector(
    (state) => state.onboardingSteps,
  );
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getOnboardingSteps(messageApi);
  };

  const columns: TableColumnsType<OnboardingStepsType> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (t) => stripHtml(t),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (d) => stripHtml(d),
    },
    {
      title: "Step Key",
      dataIndex: "stepKey",
      key: "stepKey",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (t) => <Tag color="gray">{t}</Tag>,
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
    },
    {
      title: "Parent",
      dataIndex: "parent",
      key: "parent",
      render: (p) => stripHtml(p?.title),
    },
    {
      title: "Video Url",
      dataIndex: "videoUrl",
      key: "videoUrl",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: OnboardingStepsType) => {
    switch (key) {
      case "show":
        navigate(`/onboarding-step/show`, {
          state: { onboardingStep: obj },
        });
        break;
      case "edit":
        navigate(`/onboarding-step/edit`, {
          state: { onboardingStep: obj },
        });
        break;
      case "delete":
        deleteOnboardingStep(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="tag">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "Onboarding Step",
              },
            ]}
          />
        </div>
        <SectionHeader
          dataLength={onboardingSteps?.length}
          createRoute="onboarding-step"
        />
        <Table
          sticky
          dataSource={onboardingSteps}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1300 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
